import {
  Box,
  Chip,
  FormControl,
  Input,
  MenuItem,
  Select,
  Typography,
  Checkbox,
  ListItemText,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useSelector } from "react-redux";

function AssignedToUsers({
  assignedUsers,
  setAssignedUsers,
  alreadyAssignedUsers,
  oldAssignedUsers,
  handleDetailModalClose,
  isRequestApiLoading,
  onSaveAssignedUsers,
  showButtons,
}) {
  const companyUsers = useSelector((state) => state.companyUsers.companyUsers.list);

  return (
    <FormControl sx={{ width: "100%", margin: "1rem 0rem", display: "flex" }}>
      <Typography sx={{ fontSize: "0.8rem", color: "#7b809a" }}>Assigned To</Typography>
      <Select
        multiple
        sx={{
          padding: "0.5rem 0",
          flex: "1",
          "& .MuiSelect-select": {
            padding: "0 !important",
          },
        }}
        value={assignedUsers}
        onChange={(a, b) => {
          let arr = assignedUsers;
          if (arr.map((_) => _.id).includes(b.props.value.userId)) {
            arr = arr.filter((_) => _.id !== b.props.value.userId);
          } else {
            arr.push({
              id: b.props.value.userId,
              name: b.props.value.name,
              email: b.props.value.email,
              disabled: b.props.value.disabled,
            });
          }
          setAssignedUsers(() => [...arr]);
        }}
        input={<Input />}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {selected.map((value) => (
              <Chip
                onMouseDown={(event) => {
                  event.stopPropagation();
                }}
                key={value.id}
                label={value.name}
                disabled={!!value.disabled}
                onDelete={() => {
                  const arr = assignedUsers.filter((_) => _.id !== value.id);
                  setAssignedUsers(arr);
                }}
              />
            ))}
          </Box>
        )}
      >
        {companyUsers
          .filter(
            (_) =>
              !_.disabled &&
              ((alreadyAssignedUsers.includes(_.userId) &&
                oldAssignedUsers?.some((user) => user?.id === _.userId)) ||
                !alreadyAssignedUsers.includes(_.userId))
          )
          .map((user) => (
            <MenuItem key={user.userId} value={user}>
              <Checkbox checked={assignedUsers.some((_) => _.id === user.userId)} />
              <ListItemText primary={user.name} />
            </MenuItem>
          ))
          .sort((a, b) => (a.name > b.name ? 1 : -1))}
      </Select>
      {showButtons && (
        <MDBox sx={{ display: "flex", justifyContent: "flex-end" }}>
          <MDButton
            color="gray80"
            onClick={handleDetailModalClose}
            sx={{ mt: 2, mr: 1, position: "relative" }}
          >
            Cancel
          </MDButton>
          <MDButton
            type="submit"
            color="primaryRed"
            sx={{ marginTop: "1rem" }}
            disabled={isRequestApiLoading}
            onClick={onSaveAssignedUsers}
          >
            {isRequestApiLoading ? "Loading..." : "Save"}
          </MDButton>
        </MDBox>
      )}
    </FormControl>
  );
}

export default AssignedToUsers;
